module.exports = __webpack_public_path__ + "static/media/logo.3fd70460.png";